var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.signedOutText),expression:"signedOutText"}],staticClass:"disabled-comment text-center"})}
var staticRenderFns = []

export { render, staticRenderFns }